import _regeneratorRuntime from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/opt/www/game/xcp-vue-xcll/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.push.js";
import infoList from "../../mixins/infoList";
import { syncCpConfig } from "@/api/data";
import { partnerList } from "@/api/partner";
import PartnerOptions from "../../components/serverList/partnerOptions.vue";
import { getPartnerMap } from "@/utils/dictionary";
export default {
  components: {
    PartnerOptions: PartnerOptions
  },
  name: "gameCardConfig",
  mixins: [infoList],
  data: function data() {
    return {
      partnerArray: [],
      //分页
      listApi: partnerList,
      searchInfo: {
        partner_id: ""
      }
    };
  },
  created: function created() {
    this.init();
    this.queryEvent();
  },
  methods: {
    init: function init() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res, index;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getPartnerMap();
            case 2:
              res = _context.sent;
              for (index in res) {
                _this.partnerArray.push({
                  partner_id: index,
                  partner_name: res[index]
                });
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    queryEvent: function queryEvent() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _this2.getTableData();
            case 2:
              if (!_this2.tableData || _this2.tableData && _this2.tableData.length === 0) {
                _this2.$message({
                  message: "暂无数据"
                });
              }
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    openConfig: function openConfig() {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var res;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return syncCpConfig({
                type: "c_partner"
              });
            case 2:
              res = _context3.sent;
              if (res.code === 0) {
                _this3.$message({
                  message: "同步cp配置成功",
                  type: "success"
                });
              }
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    openPop: function openPop() {
      this.$notify({
        title: "卡牌配置",
        dangerouslyUseHTMLString: true,
        message: "<div>(1)显示卡牌配置版本和列表，包含卡牌Id，卡牌名称，卡牌品质，卡牌星级</div>" + "<div>(2)调用研发接口，更新卡牌配置，研发接口可返回json配置文件，包含配置版本，卡牌配置列表。</div>",
        duration: 0
      });
    }
  }
};